import { render, staticRenderFns } from "./AttendanceMobilityRequests.vue?vue&type=template&id=019d1279"
import script from "./AttendanceMobilityRequests.vue?vue&type=script&lang=js"
export * from "./AttendanceMobilityRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports